
import Vue from 'vue';
import { Component, Inject, Prop, Watch } from 'vue-property-decorator';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Toasted from 'vue-toasted';
import Datepicker from 'vuejs-datepicker';
import { de } from 'vuejs-datepicker/dist/locale';
import { WindowType } from '../../../util';
import { TestEquipmentDevice, TestEquipmentTest } from '../../backend/backendapi';
import { FileStatusMessage, StatusMessage } from '../../dropzone/dropzone.util';
import { equipmentNumber } from '../util';
import State from '../State';
import TestEquipmentMeasurements from './TestEquipmentMeasurements';
import DropZone from '../../dropzone/DropZone';

declare var window: WindowType;

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    Datepicker,
    DropZone,
    TestEquipmentMeasurements,
    vSelect,
    ImageViewer: require('../../imageviewer/imageviewer.vue.html').default,
  },
})
export default class TestEquipmentTestEdit extends Vue {
  @Prop({ required: true })
  equipment!: TestEquipmentDevice;
  @Prop({ required: true })
  test!: TestEquipmentTest;
  @Prop({ default: true })
  editable!: boolean;

  @Inject({ from: 'state' })
  readonly state!: State;

  datepickerDE: any = de;

  get allowMediaDelete(): boolean {
    return window.application.permissions.testequipment.mediadelete;
  }

  get eqNumber(): string {
    return equipmentNumber(this.equipment, this.state.kindsStore.kindTypes, this.state.groupsStore.groupTypes, this.state.placeOfUsesStore.placeOfUseTypes);
  }

  fileUploaded(status: FileStatusMessage): void {
    if (status.type !== StatusMessage.success) {
      return;
    }
    this.$emit('fileAdded', status.fileId);
  }

  removeMedia(mediaId: string): void {
    console.log('rem', mediaId);
    let index = this.test.files.findIndex(e => e.id === mediaId);
    if (index > -1) {
      this.test.files.splice(index, 1);
    }
  }

  @Watch('test.measurementSpecifications', { immediate: true })
  onTestMeasurementSpecifications(): void {
    if (this.test.measurementSpecifications?.length && !this.test.error) {
      this.test.error = 'n/a';
    }
  }
}
